import { render } from "./arrayVideo.vue?vue&type=template&id=5e286b61&scoped=true"
import script from "./arrayVideo.vue?vue&type=script&lang=js"
export * from "./arrayVideo.vue?vue&type=script&lang=js"

import "./arrayVideo.vue?vue&type=style&index=0&id=5e286b61&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e286b61"]])

export default __exports__